import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody } from '@/shared/api/generated';

type ImportPath = '/v1/workspaces/{workspace_id}/helpscout/import';
type ImportParams = PathParams<ImportPath, 'post'> &
  RequestBody<ImportPath, 'post'>;

/**
 * Helpscout 피드백 일회성 가져오기
 */
export const importHelpscoutFeedback = ({
  workspace_id,
  start_date,
  end_date,
}: ImportParams): Promise<{ job_id?: string }> =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/helpscout/import`, {
      start_date,
      end_date,
    })
    .then((res) => res.data);
